import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type {
  SupplierDashboardClient,
  SupplierDashboardDto,
} from '@/api/supplier-dashboard-client';
import { useSupplierDashboardClient } from '@/api/supplier-dashboard-client-context';

// =============================================================================
// use-supplier-dashboard.ts — Hook TanStack Query du TABLEAU DE BORD FOURNISSEUR (DBU §3.2, D3b).
// =============================================================================
// Lecture PURE (useQuery). Le client effectif vient du SupplierDashboardClientProvider (doublable).
// ZÉRO règle métier : l'autorité (session/withTenant, partition/tri/complétion) est l'API. Aucune donnée
// métier en localStorage (RULE_REF_006).

const SUPPLIER_DASHBOARD_KEY = ['supplier-dashboard'] as const;

/** Clé de query du tableau de bord fournisseur. */
export function supplierDashboardKey(): readonly unknown[] {
  return [...SUPPLIER_DASHBOARD_KEY];
}

/** GET tableau de bord du fournisseur en session (participations actives + historique + complétion). */
export function useSupplierDashboard(): UseQueryResult<SupplierDashboardDto, Error> {
  const client: SupplierDashboardClient = useSupplierDashboardClient();
  return useQuery<SupplierDashboardDto, Error>({
    queryKey: supplierDashboardKey(),
    queryFn: () => client.getDashboard(),
  });
}
